import { motion } from 'framer-motion';
import ClickToPlayMuxVideo from './ui/ClickToPlayMuxVideo';
import { BOOK_VIDEO_PLAYBACK_ID } from '../data/video';
import BookCallCTA from './BookCallCTA';

export default function FounderVideoSection() {
  return (
    <section className="py-8 sm:py-16 bg-white relative overflow-hidden">
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-6"
        >
          <p className="text-sm font-bold tracking-[0.2em] text-[#d4a10d] uppercase mb-3">
            From the founder
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
            Why I built this
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mt-4">
            The lead follow-up problem is killing your conversion rate. Here is what we built to fix it.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <ClickToPlayMuxVideo
            playbackId={BOOK_VIDEO_PLAYBACK_ID}
            title="Founder introduction | Point Break Systems"
          />
          <p className="text-center mt-4 text-sm text-[#68675e]">
            Want to hear it first?{' '}
            <a href="tel:+17097020468" className="underline underline-offset-4 text-[#8a6414]">
              Try the AI
            </a>
          </p>
          <div className="text-center mt-5"><BookCallCTA /></div>
        </motion.div>


      </div>
    </section>
  );
}

